<template> </template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    menuItems() {
      let out = [];
      if (this.cat) {
        for (let [id, category] of Object.entries(this.cat)) {
          let subItems = [];
          if (category.items) {
            for (let [ind, catg] of Object.entries(category.items)) {
              subItems.push({
                to: {
                  name: "subCategory",
                  params: { groupId: catg.id, pGroupId: category.id },
                },
                name: catg.name,
                id: parseInt(catg.id),
              });
            }
          }

          out.push({
            to: { name: "category", params: { groupId: category.id } },
            name: category.name,
            items: subItems,
            id: parseInt(category.id),
          });
        }
      }
      return out;
    },
    ...mapState(["cat"]),
  },
};
</script>
